import React, { useEffect, useState } from 'react'

import { ReactComponent as CsnLogo } from 'assets/images/logo_csn.svg'
import moment from 'moment'
import Logotipo from 'assets/images/logotipo_csn.png'
import {
  Card,
  Span,
  Row,
  TableBodyStyled,
  TableCellStyled,
  TableRowStyled,
  TableContainerStyled,
  TableStyled,
  TableHeadStyled,
  CollapseColumn,
  Button,
  Image,
  Col
} from 'components'
import { LoadingIcon } from 'components/Icons'
import { ExcelIcon, PdfIcon } from 'components/Svg'
import { useLoading, useModal, useReportPrint } from 'hooks'
import { useHistory, useLocation } from 'react-router-dom'
import {
  ReportsAcessServices,
  RequestGetVisualizar
} from 'services/NGT/ReportsAcess'
import { COLORS, FONTS, FORMAT, SPACING } from 'utils'
import { createArrayCopy } from 'utils/functions'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Box, LinearProgress } from '@mui/material'

interface CollapseProps {
  isOpen: boolean
  content: any
}

const SupplierView: React.FC = () => {
  const { setLoading, setMsgErro, setMsgSucesso } = useLoading()
  const { goBack } = useHistory()
  const { state } = useLocation<RequestGetVisualizar>()
  const { handlePrintRelatorioDeAcessoPorFornecedor } = useReportPrint()

  const { showModal } = useModal()

  const [downloadExcel, setDownloadExcel] = useState<boolean>(false)
  const [datasVisualizar, setDatasVisualizar] = useState({
    dataMesFim: '',
    dataMesInicial: ''
  })
  const [grupos, setGrupos] = useState<CollapseProps[] | undefined>()

  useEffect(() => {
    setLoading('loading')

    if (!state) {
      goBack()
      return
    }

    getRelatorio()
  }, [])

  const isRelatorioTotal = (objEnvio: RequestGetVisualizar) => {
    if (objEnvio.fornecedoresIds.length > 0) return false
    return true
  }

  const [isCollapsed, setIsCollapsed] = useState(false)

  const getRelatorio = async () => {
    const objEnvio: RequestGetVisualizar = {
      ...(state.contratosIds && {
        contratosIds: state.contratosIds
      }),
      ...(state?.subcontratadasIds && {
        subcontratadasIds: state.subcontratadasIds
      }),
      ...(state?.fornecedoresIds && {
        fornecedoresIds: state.fornecedoresIds
      }),
      ...(state?.dataFim && {
        dataFim: state.dataFim
      }),
      ...(state?.dataIni && {
        dataIni: state.dataIni
      }),
      centrosIds: state?.centrosIds,
      empresasIds: state?.empresasIds,
      flStatus: state?.flStatus,
      perfil: state?.perfil,
      unidadeGestoraId: state?.unidadeGestoraId
    }

    setIsCollapsed(!isRelatorioTotal(objEnvio))

    ReportsAcessServices()
      .getFornecedor(objEnvio)
      .then((response) => {
        if (response.status !== 200) {
          throw new Error(
            response?.data?.message ||
            response?.data?.mensagem ||
            'Erro obter relatório.'
          )
        }
        const listTemp = []
        response.data.grupos?.forEach((element) => {
          listTemp.push({
            content: element,
            isOpen: true
          })
        })
        setGrupos(listTemp)
        setDatasVisualizar({
          dataMesFim: response.data.dataMesFim,
          dataMesInicial: response.data.dataMesInicial
        })

        setLoading('idle')
      })
      .catch((error) => {
        setLoading('idle')
        if (error?.response?.data?.mensagem) {
          showModal({
            hideButtonCancel: true,
            message: error?.response?.data?.mensagem,
            type: 'alert'
          })
          // setMsgSucesso(error?.response?.data?.mensagem, 'Atenção', 'alert')
          return
        }
        // setMsgErro('Erro ao obter relatório.')
        // setLoading('error')
        showModal({
          hideButtonCancel: true,
          message: error?.message || 'Não foi possivel baixar excel.',
          type: 'error'
        })
      })
  }

  const handleExcel = () => {
    setDownloadExcel(true)
    if (state.dataIni == null || state.dataIni?.toString() === '') {
      delete state.dataIni
    }
    if (state.dataFim == null || state.dataFim?.toString() === '') {
      delete state.dataFim
    }
    ReportsAcessServices()
      .getFornecedorExcel(state)
      .then((response) => {
        const url =
          'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' +
          response.data
        const downloadLink = document.createElement('a')
        downloadLink.href = url
        downloadLink.download = 'relatorio-de-acesso-fornecedor.xlsx'
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
        setDownloadExcel(false)
      })
      .catch((error) => {
        // setMsgErro(error?.message || 'Não foi possivel baixar excel.')
        setDownloadExcel(false)
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: error?.message || 'Não foi possivel baixar excel.',
          type: 'error'
        })
      })
  }

  const contents = grupos && grupos.map((el) => el.content)
  const resultados =
    contents &&
    contents.map((el) => {
      const resultado = el.resultado.map((re) => ({
        ...re,
        dir: el.dir,
        de: el.de,
        ger: el.ger,
        gg: el.gg
      }))
      return {
        isOpen: isCollapsed,
        fornecedorChave: el.fornecedorChave,
        resultado
      }
    })

  const [res, setRes] = useState<any>([])
  const [slicedList, setSlicedList] = useState<any[]>([])
  const DEFAULT_SCROLL_LOAD_ITEMS = 10

  const nextPagination = (grupos: any[]) => {
    setTimeout(() => {
      const currentLength = slicedList.length
      const newItems = grupos.slice(
        currentLength,
        currentLength + DEFAULT_SCROLL_LOAD_ITEMS
      )
      setSlicedList((prevState) => prevState.concat([...newItems]))
    }, 1000)
  }

  useEffect(() => {
    setRes(resultados)
    setSlicedList(
      isCollapsed ? resultados?.slice(0, DEFAULT_SCROLL_LOAD_ITEMS) : resultados
    )
  }, [res && res.length > 0 ? null : resultados])

  const handleCollpasePdf = (index: number) => {
    const cpySliced = createArrayCopy(slicedList)
    cpySliced[index].isOpen = !cpySliced[index].isOpen
    setSlicedList(cpySliced)
    const cpy = createArrayCopy(res)
    cpy[index].isOpen = !cpy[index].isOpen
    setRes(cpy)
  }

  return (
    <>
      <Card
        boxShadow="0px -1px 32px rgba(50, 50, 71, 0.12), 0px 24px 32px rgba(50, 50, 71, 0.12);"
        borderRadius="0px 10px 0px 0px"
        marginTop={SPACING.spacing20}
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
      >
        <div>
          <HeaderSupplierTitle />
          <HeaderSupplierView datasRelatorio={datasVisualizar} />
          <Card padding="1rem">
            <Row justifyContent="flex-end" alignItems="center">
              <RowPdfExcel
                handlePDF={() =>
                  handlePrintRelatorioDeAcessoPorFornecedor({
                    filename: `relatório-de-acesso-contrato-${moment().format(
                      'DD-MM-YYYY'
                    )}`,
                    title: 'RELATÓRIO DE ACESSO POR FORNECEDOR',
                    mesInicial: datasVisualizar.dataMesInicial || '---',
                    mesFinal: datasVisualizar.dataMesFim || '---',
                    data: res.map((contract) => ({
                      nmFornecedor: contract.fornecedorChave,
                      body: contract.resultado.map((result) => [
                        result.cdContrato,
                        result.de,
                        result.dir,
                        result.gg,
                        result.ger,
                        FORMAT.documento(result.cpfpassaporte),
                        result.colaborador,
                        FORMAT.contatoInternacional(result.contato),
                        result.email,
                        result.dtValidade,
                        result.perfil,
                        result.status
                        // result.cdContrato
                      ])
                    }))
                  })
                }
                handleExcel={handleExcel}
                downloadExcel={downloadExcel}
              />
              <Button
                marginTop={SPACING.spacing20}
                marginBottom={SPACING.spacing20}
                marginRight={SPACING.spacing5}
                text="Voltar"
                variantButton="outlined"
                onClick={() => goBack()}
              />
            </Row>
            <InfiniteScroll
              dataLength={slicedList?.length}
              next={() => nextPagination(res)}
              hasMore={res?.length > slicedList?.length}
              loader={
                <Box sx={{ width: '100%', marginBottom: '20px' }}>
                  <LinearProgress />
                </Box>
              }
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>Final da listagem</b>
                </p>
              }
              releaseToRefreshContent={
                <h3 style={{ textAlign: 'center' }}>&#8593; Atualizando...</h3>
              }
            >
              {slicedList ? (
                slicedList?.map((el: any, index: number) => (
                  <CollapseColumn
                    key={index.toString()}
                    nmFornecedor={el.fornecedorChave}
                    isOpen={el.isOpen}
                    //isOpen={true}
                    toggleExpand={() => handleCollpasePdf(index)}
                    index={index}
                    onlyFornecedor
                  >
                    <TableSupplierView data={el?.resultado} />
                  </CollapseColumn>
                ))
              ) : (
                <></>
              )}
            </InfiniteScroll>
          </Card>
        </div>
      </Card>
    </>
  )
}

const HeaderSupplierTitle = () => (
  <Card backgroundColor={COLORS.headerColor} padding={SPACING.spacing20}>
    <Row alignItems="center" justifyContent="left">
      <Col gap=".7rem" alignItems="center" justifyContent="left">
        <CsnLogo width="62" height="40" />
        <Image src={Logotipo} width="3.8rem" />
      </Col>
    </Row>
    <Span
      text="RELATÓRIO DE ACESSO POR FORNECEDOR"
      color={COLORS.blueFonts}
      fontSize="24px"
      fontWeight={FONTS.bold}
      textTransform="uppercase"
      style={{
        display: 'flex',
        justifyContent: 'center'
      }}
    />
  </Card>
)

const HeaderSupplierView = ({ datasRelatorio }) => (
  <Card backgroundColor={COLORS.secondary} padding="1rem">
    <Row alignItems="center" justifyContent="center">
      <Span
        text={`Mês Inicial: ${datasRelatorio.dataMesInicial || '---'}`}
        marginRight={SPACING.spacing15}
        fontSize="16px"
        fontWeight="700"
      />
      <Span
        text={`Mês Final: ${datasRelatorio.dataMesFim || '---'}`}
        fontSize="16px"
        fontWeight="700"
      />
    </Row>
  </Card>
)

const RowPdfExcel = ({ handlePDF, handleExcel, downloadExcel }) => (
  <Row
    alignItems="center"
    justifyContent="flex-end"
    marginTop={SPACING.spacing15}
    marginBottom={SPACING.spacing15}
  >
    <PdfIcon onClick={handlePDF} />
    {downloadExcel ? (
      <LoadingIcon colorIcon={COLORS.blueFonts} />
    ) : (
      <ExcelIcon style={{ marginLeft: `{SPACING.spacing15}` }} onClick={handleExcel} />
    )}
  </Row>
)

const TableSupplierView = ({ data }) => (
  <TableContainerStyled>
    <TableStyled>
      <TableHeadStyled>
        <TableRowStyled>
          <TableCellStyled align="left">Contrato</TableCellStyled>
          <TableCellStyled align="left">DE</TableCellStyled>
          <TableCellStyled align="left">DIR</TableCellStyled>
          <TableCellStyled align="left">GG</TableCellStyled>
          <TableCellStyled align="left">GER</TableCellStyled>
          <TableCellStyled align="left">CPF/Passaporte</TableCellStyled>
          <TableCellStyled align="left">Colaborador</TableCellStyled>
          <TableCellStyled align="left">Contato</TableCellStyled>
          <TableCellStyled align="left">E-mail</TableCellStyled>
          <TableCellStyled align="left">Vld. Acesso</TableCellStyled>
          <TableCellStyled align="left">Perfil</TableCellStyled>
          <TableCellStyled align="left">Status</TableCellStyled>
          <TableCellStyled align="left">Contrato Atuação</TableCellStyled>
        </TableRowStyled>
      </TableHeadStyled>
      <TableBodyStyled>
        {data?.map((el: ResponseAcesso) => (
          <TableRowStyled key={el.cpfpassaporte}>
            <TableCellStyled align="left">
              {el.cdContrato || '- - - -'}
            </TableCellStyled>
            <TableCellStyled align="left">
              {el?.de || ' - - - -'}
            </TableCellStyled>
            <TableCellStyled align="left">
              {el?.dir || ' - - - -'}
            </TableCellStyled>
            <TableCellStyled align="left">
              {el?.gg || ' - - - -'}
            </TableCellStyled>
            <TableCellStyled align="left">
              {el?.ger || ' - - - -'}
            </TableCellStyled>
            <TableCellStyled align="left">
              {FORMAT.documento(el.cpfpassaporte) || '- - - - '}
            </TableCellStyled>
            <TableCellStyled align="left">
              {el.colaborador || '- - - -'}
            </TableCellStyled>
            <TableCellStyled align="left">
              {el.contato || '- - - -'}
            </TableCellStyled>
            <TableCellStyled align="left">
              {el.email || '- - - -'}
            </TableCellStyled>
            <TableCellStyled align="left">
              {el.dtValidade || '- - - -'}
            </TableCellStyled>
            <TableCellStyled align="left">
              {el.perfil || '- - - -'}
            </TableCellStyled>
            <TableCellStyled align="left">
              {el.status || '- - - -'}
            </TableCellStyled>
            <TableCellStyled align="left">
              {el.cdContrato || '- - - -'}
            </TableCellStyled>
          </TableRowStyled>
        ))}
      </TableBodyStyled>
    </TableStyled>
  </TableContainerStyled>
)

export interface ResponseAcesso {
  contrato: string
  fornecedor: string
  contratada?: any
  subcontratada?: any
  dtValidade: string
  email: string
  de: string
  dir?: any
  gg?: any
  ger?: any
  cdContrato?: string
  cpfpassaporte: string
  colaborador: string
  contato: string
  vldAcesso: Date
  perfil: string
  status: string
  contraparte?: any
  valorAtual?: any
}

export default SupplierView
